import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import FreelanceSearchCard from '../../../../components/SearchCard/Freelance/FreelanceSearchCard.jsx';
import FreelanceSearchListItem
  from '../../../../components/Freelance/Component/SearchListItem/FreelanceSearchListItem.jsx';
import SearchResults from '../../../Search/Components/SearchResults.jsx';

import conf from '../../../../conf.js';
import {generate} from '../../../../routes.js';

import {isUserDo} from "../../../../../shared/services/userService.js";

class FreelanceSearchResultsContainer extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object,
    flattenSearchObject: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    isAdmin: PropTypes.bool.isRequired,
    search: PropTypes.func.isRequired,
    scores: PropTypes.object,
    searchQuery: PropTypes.object.isRequired,
    searchPage: PropTypes.number,
    searchRouteName: PropTypes.string.isRequired,
    searchTarget: PropTypes.string.isRequired,
  };

  static defaultProps = {
    loading: true,
    scores: [],
    searchPage: 1,
  };

  static filters = {
    orders: [
      {
        name: 'sort_tjm',
        label: 'TJM',
        tooltip: 'Tri par TJM',
        mustBeAdmin: true,
      },
      {
        name: 'sort_availability',
        label: 'Disponibilité',
        tooltip: 'Tri par disponibilité',
        mustBeConnected: true,
      },
      {
        name: 'sort_date_next_action',
        label: 'Date',
        tooltip: 'Tri par date de relance',
        mustBeAdmin: true,
      }
    ],
    freelanceSearchOrders : [
      {
        name: 'sort_availability',
        label: 'Disponibilité',
        tooltip: 'Tri par disponibilité',
        mustBeConnected: true,
      },
    ],
    adminOnlyRequirements: true,
    requirementChoices: [
      {text: 'Défaut'},
      {value: 1, text: 'ID (Sans le #)'},
      {value: 2, text: 'Nom / Prénom'},
      {value: 3, text: 'Email'},
      {value: 4, text: 'Téléphone'},
      {value: 5, text: 'Commentaires'}
    ]
  };

  renderFreelances = (freelances) => {
    const searchLimit = parseInt(this.props?.searchQuery.limit ?? conf.search.limits.cards, 10);
    const Component = searchLimit === conf.search.limits.cards ? FreelanceSearchCard : FreelanceSearchListItem;
    const search = this.props.flattenSearchObject(this.props.searchQuery);

    const freelancesItems = freelances.map((freelance, index) =>
      <Component
        currentUser={this.props.currentUser}
        freelance={freelance}
        isAdmin={this.props.isAdmin}
        key={freelance.id}
        link={this.generateLink(search, index)}
        score={(this.props.isAdmin && this.props.scores[freelance.id]) ? this.props.scores[freelance.id] : false}
      />
    );

    if (searchLimit === conf.search.limits.cards) {
      return <div className="row">{freelancesItems}</div>;
    }

    return <ul className="p-0">{freelancesItems}</ul>;
  };

  generateLink = (search, offset) => generate({
    name: 'search.view',
    parameters: {offset, page: this.props.searchPage},
    search: search
  });

  render() {
    return <SearchResults
      canToggleView={true}
      filters={FreelanceSearchResultsContainer.filters}
      flattenSearchObject={this.props.flattenSearchObject}
      isAdmin={this.props.isAdmin}
      isAvailability={true}
      isCity={{all: true, remote: true}}
      isLanguages={this.props.isAdmin || isUserDo(this.props.currentUser)}
      isPrices={this.props.isAdmin}
      isSecteurs={this.props.isAdmin || isUserDo(this.props.currentUser)}
      isSkill={true}
      isItSkills={this.props.isAdmin || isUserDo(this.props.currentUser)}
      isFollowedByMe={this.props.currentUser.isBusinessManager}
      loading={this.props.loading}
      search={this.props.search}
      renderResults={this.renderFreelances}
      searchQuery={this.props.searchQuery}
      searchRouteName={this.props.searchRouteName}
      topologies={conf.search.topologies.freelances}
      target={this.props.searchTarget}
    />;
  }
}

export default connect(
  (state) => ({
    scores: state.search.scores,
  }),
)(FreelanceSearchResultsContainer);
